// import { DOMAIN } from 'Env';

//const DOMAIN = config.DOMAIN;
export const getMerchantSubdomain = (): string => {
    const url = window.location.hostname;
    return url;
    //return url.substring(0, url.indexOf(DOMAIN));
};
